import { render, staticRenderFns } from "./new-request-landing.component.vue?vue&type=template&id=6a5873c0&"
import script from "./new-request-landing.component.ts?vue&type=script&lang=ts&"
export * from "./new-request-landing.component.ts?vue&type=script&lang=ts&"
import style0 from "./new-request-landing.component.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports